import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { buildWorkOrderCreatePayload } from '#/api/momMgmt/workOrder/serializeWorkOrderWrite';

/**
 * POST /mom/work-order/draft-batch → 201
 * items[] 經 buildWorkOrderCreatePayload → bom_mtr_selections／source_group_mtr_id／selected_mtr_id
 * @param {{ customerOrderId: string, items: object[] }} payload
 * @see docs/API_MOMMGMT_WORK_ORDER.md
 */
export async function createWorkOrderDraftBatch(payload) {
  const items = (payload?.items ?? []).map((item) => buildWorkOrderCreatePayload(item));
  const { data: raw } = await request.post(
    '/mom/work-order/draft-batch',
    keysToSnake({
      customerOrderId: payload?.customerOrderId,
      items,
    }),
  );
  return parseVer4DetailResponse(raw);
}
